module.exports = __webpack_public_path__ + "assets/icon-enroll-lottery-cda5f017.png";